import { mapState, mapActions, mapMutations } from 'vuex'
import { MODULE_NAME, ACTIONS, MUTATIONS } from '@/store/locations/constants'
import { MODULE_NAME as MODULE_NAME_SITE, ACTIONS as ACTIONS_SITE } from '@/store/site/constants'

export default {
  name: 'LocationsList',
  mixins: [],
  components: {
    PanelCenters: () => import(/* webpackChunkName: "PanelCenters" */ '@/views/locations/panel-centers/PanelCenters.vue'),
    PanelStands: () => import(/* webpackChunkName: "PanelStands" */ '@/views/locations/panel-stands/PanelStands.vue'),
    PanelPois: () => import(/* webpackChunkName: "PanelPois" */ '@/views/locations/panel-pois/PanelPois.vue')
  },
  props: {
    activeTab: {
      type: String,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(MODULE_NAME, ['viewportFilter', 'groups', 'adverts', 'shops', 'pois']),
    shopCount () {
      return this.viewportFilter.enabled
        ? this.viewportFilter.shops.length
        : this.shops.meta.count
    },
    advertCount () {
      return this.viewportFilter.enabled
        ? this.viewportFilter.adverts.length
        : this.adverts.meta.count
    },
    poisCount () {
      return this.viewportFilter.enabled
        ? this.viewportFilter.pois.length
        : this.pois.meta.count
    }
  },
  beforeDestroy () {
    this[MUTATIONS.TOGGLE_VIEWPORT_FILTER](false)
  },
  methods: {
    ...mapActions(MODULE_NAME, [ACTIONS.FETCH_SHOPS, ACTIONS.FETCH_ADVERTS, ACTIONS.FETCH_POIS]),
    ...mapMutations(MODULE_NAME, [MUTATIONS.TOGGLE_VIEWPORT_FILTER]),
    ...mapActions(MODULE_NAME_SITE, [ ACTIONS_SITE.FETCH_BACK_LINK ]),
    setActiveTab (tab) {
      // console.log('setActiveTab', tab)
      if (tab.id === 'stands' || tab.id === 'pois') {
        this[ACTIONS_SITE.FETCH_BACK_LINK]({ payload: '/map' })
      }
      this.$emit('onTabChange', tab)
    },
    async fetchShopsPage () {
      const needsMore = this.shops.data.length < this.shops.meta.count
      if (!needsMore) {
        return
      }
      const nextPage = this.shops.meta.page + 1
      await this[ACTIONS.FETCH_SHOPS]({ meta: 1, page: nextPage, ordering: 'name' })
    },
    async fetchAdvertsPage () {
      const needsMore = this.adverts.data.length < this.adverts.meta.count
      if (!needsMore) {
        return
      }

      const nextPage = this.adverts.meta.page + 1
      await this[ACTIONS.FETCH_ADVERTS]({ meta: 1, page: nextPage, ordering: 'advert_id' })
    },
    async fetchPoisPage () {
      const needsMore = this.pois.data.length < this.pois.meta.count
      if (!needsMore) {
        return
      }

      const nextPage = this.pois.meta.page + 1
      await this[ACTIONS.FETCH_POIS]({ meta: 1, page: nextPage, ordering: 'name' })
    }
  }
}
